var map = {
	"./game-ALLBET.png": 72530,
	"./game-BTI2.png": 43489,
	"./game-EGP_AG.png": 74828,
	"./game-EGP_BBIN.png": 68242,
	"./game-EGP_CQ9.png": 1914,
	"./game-EGP_CR.png": 33486,
	"./game-EGP_FC.png": 99591,
	"./game-EGP_JDB.png": 74477,
	"./game-EGP_KY.png": 90416,
	"./game-EGP_LEG.png": 46592,
	"./game-HRG.png": 44905,
	"./game-PG.png": 32363,
	"./game-PP.png": 80254,
	"./game-TIKI.png": 51641,
	"./game-WALI.png": 91741,
	"./game-WM.png": 49217,
	"./game-XBB.png": 14537,
	"./game-default.png": 13745
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7705;